// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import "./ui/shell.css";
import ThemeVars from "./ui/ThemeVars";


import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeVars />
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
